import React from 'react'
import logo from '../../images/wordtracker-logo-black.png';

export default function SignUpForm({title, showTitle, children}) {
  return (
    <div className='sign-up-form'>
      <div className='padlock-motif'></div>
      { showTitle && <>
        <img className='wt-logo-in-form' src={logo} alt='Wordtracker logo' />
        <h4>
          <i className="fa-regular fa-square-check"></i>
          {title}
        </h4>
      </>}
      {children}
    </div>
  )
}